// frontend/src/app/shared/components/feature-lock/plan-badge.component.ts
import { Component, Input, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PlanFeatureService } from '../../../services/plan-feature.service';
import { type FeatureKey } from '../../config/plan-features';

/**
 * Badge inline 🔒 à placer à côté d'un label de fonctionnalité.
 *
 * Usage:
 * <span>Statistiques avancées</span>
 * <app-plan-badge [feature]="FEATURES.ADVANCED_STATS" />
 *
 * Affiche rien si accessible, ou un badge "🔒 Pro" si verrouillé.
 */
@Component({
  selector: 'app-plan-badge',
  standalone: true,
  imports: [RouterModule],
  template: `
    @if (!hasAccess()) {
      <a
        routerLink="/subscription"
        class="inline-flex items-center gap-1 text-xs bg-gray-100 dark:bg-slate-800 text-gray-500 dark:text-gray-400 px-2 py-0.5 rounded-full hover:bg-purple-50 dark:bg-purple-900/20 hover:text-purple-600 transition cursor-pointer"
        [title]="'Disponible avec le plan ' + requiredPlanLabel"
      >
        🔒 {{ requiredPlanLabel }}
      </a>
    }
  `,
})
export class PlanBadgeComponent {
  private planFeatureService = inject(PlanFeatureService);

  @Input({ required: true }) feature!: FeatureKey;

  readonly hasAccess = computed(() => {
    return this.planFeatureService.canAccess(this.feature);
  });

  get requiredPlanLabel(): string {
    return this.planFeatureService.getRequiredPlanLabel(this.feature);
  }
}
